/**
 * @file LegalRequisitesButtons.tsx
 * @description Кнопки «Из реквизитов» под текстом документа (phase19;
 * вынесено из LegalDocumentEditPage в phase19.16): дописывают в конец текста
 * блок из основной карточки «Реквизиты» магазина.
 */

import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";

import { Button } from "../ui/button";
import { listLegalProfiles, type LegalProfileDto } from "../../lib/api-crm";
import { bankBlockHtml, contactsBlockHtml, hasBankDetails, sellerBlockHtml } from "../../lib/legal/legal-requisites-blocks";

interface Props {
  /** Дописать HTML в конец текста. */
  onAppend: (html: string) => void;
  disabled?: boolean;
}

export function LegalRequisitesButtons({ onAppend, disabled }: Props) {
  const { slug } = useParams<{ slug: string }>();
  const [profile, setProfile] = useState<LegalProfileDto | null>(null);

  useEffect(() => {
    let cancelled = false;
    listLegalProfiles()
      .then(({ items }) => !cancelled && setProfile(items.find((p) => p.isDefault) ?? items[0] ?? null))
      .catch(() => !cancelled && setProfile(null));
    return () => {
      cancelled = true;
    };
  }, []);

  const off = disabled || !profile;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="type-caption text-on-surface-variant">Из реквизитов:</span>
      <Button type="button" variant="outline" size="sm" disabled={off} onClick={() => profile && onAppend(sellerBlockHtml(profile))}>
        Реквизиты продавца
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={off || !profile || !hasBankDetails(profile)}
        onClick={() => profile && onAppend(bankBlockHtml(profile))}
      >
        Банковские реквизиты
      </Button>
      <Button type="button" variant="outline" size="sm" disabled={off} onClick={() => profile && onAppend(contactsBlockHtml(profile))}>
        Контакты
      </Button>
      {!profile ? (
        <Link to={`/shop/${slug}/settings/legal-profiles`} className="type-caption inline-flex min-h-12 items-center text-primary hover:underline">
          Заполните «Реквизиты» →
        </Link>
      ) : null}
    </div>
  );
}
